import { createTheme } from "@mui/material/styles";

export const palette = {
  orange: "#f06321",
  orangeDark: "#c9521b",
  teal: "#215E61",
  tealLight: "#3D7A7D",
  ink: "#1D2128",
  mist: "#F4F2F2",
  white: "#FFFFFF",
};

export function makeTheme(mode = "light") {
  const dark = mode === "dark";
  return createTheme({
    palette: {
      mode,
      primary: { main: palette.orange, dark: palette.orangeDark, contrastText: palette.ink },
      secondary: { main: palette.teal, light: palette.tealLight, contrastText: palette.white },
      info: { main: palette.teal },
      background: dark
        ? { default: palette.ink, paper: "#292E36" }
        : { default: palette.mist, paper: palette.white },
      text: dark
        ? { primary: palette.mist, secondary: "#B8BEC6" }
        : { primary: palette.ink, secondary: "#58616D" },
      divider: dark ? "rgba(244,242,242,.14)" : "rgba(29,33,40,.16)",
    },
    // Keep the UI crisp. MUI multiplies numeric `sx` radii by this value,
    // so the previous 20px base turned `borderRadius: 3` into 60px corners.
    shape: { borderRadius: 4 },
    typography: {
      fontFamily: '"Figtree", "Segoe UI", sans-serif',
      h1: { fontFamily: '"Caprasimo", Georgia, serif', fontWeight: 400 },
      h2: { fontFamily: '"Caprasimo", Georgia, serif', fontWeight: 400 },
      h3: { fontFamily: '"Caprasimo", Georgia, serif', fontWeight: 400 },
      h4: { fontFamily: '"Caprasimo", Georgia, serif', fontWeight: 400 },
      button: { fontWeight: 700 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { minHeight: "100vh" },
          "::selection": { background: "rgba(255,158,32,.32)" },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            backgroundColor: dark ? "rgba(29,33,40,.92)" : "rgba(244,242,242,.92)",
            color: dark ? palette.mist : palette.ink,
            backdropFilter: "blur(10px)",
            boxShadow: "none",
            borderBottom: `1px solid ${dark ? "rgba(244,242,242,.14)" : "rgba(29,33,40,.12)"}`,
            "&.MuiAppBar-positionSticky": {
              top: 56,
            },
          },
        },
      },
      MuiButton: { styleOverrides: { root: { textTransform: "none", borderRadius: 8, paddingInline: 18 } } },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontWeight: 600,
            "&:not(.MuiChip-outlined)": {
              backgroundColor: dark ? "rgba(244,242,242,.08)" : "rgba(29,33,40,.06)",
            },
          },
        },
      },
      MuiCard: {
        defaultProps: { elevation: 0 },
        styleOverrides: {
          root: {
            borderRadius: 12,
            backgroundImage: "none",
            boxShadow: "none",
            transition: "border-color 160ms ease, background-color 160ms ease",
            "&.MuiCard-outlined": {
              borderColor: dark ? "rgba(244,242,242,.12)" : "rgba(29,33,40,.12)",
            },
            "@media (hover: hover)": {
              "&.MuiCard-outlined:hover": {
                borderColor: dark ? "rgba(244,242,242,.24)" : "rgba(29,33,40,.24)",
              },
            },
          },
        },
      },
      MuiSkeleton: {
        defaultProps: { animation: "wave" },
        styleOverrides: {
          root: { transformOrigin: "center" },
        },
      },
      MuiPaper: { styleOverrides: { rounded: { borderRadius: 12, backgroundImage: "none" } } },
      MuiDialog: { styleOverrides: { paper: { borderRadius: 10 } } },
      MuiTextField: { defaultProps: { variant: "outlined" } },
      MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8 } } },
    },
  });
}
